// extracted by mini-css-extract-plugin
module.exports = {"Annotation":"Annotation_Annotation__95T5X"};